import { render, staticRenderFns } from "./TestimonialFemale.vue?vue&type=template&id=3e4c8508&scoped=true&"
import script from "./TestimonialFemale.vue?vue&type=script&lang=js&"
export * from "./TestimonialFemale.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialFemale.vue?vue&type=style&index=0&id=3e4c8508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c8508",
  null
  
)

export default component.exports